import { render, staticRenderFns } from "./evaluation.vue?vue&type=template&id=504b46a3&"
import script from "./evaluation.vue?vue&type=script&lang=js&"
export * from "./evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports